import React, { useEffect, useState } from 'react';
import { fetchContenido } from '../services/api';

function Seccion({ icono, titulo, texto, color }) {
  return (
    <div style={{ ...st.seccion, borderTop: `4px solid ${color}` }} className="mv-seccion">
      <div style={st.seccionHeader}>
        <span style={{ fontSize: 32 }}>{icono}</span>
        <h2 style={{ ...st.seccionTitulo, color }}>{titulo}</h2>
      </div>
      <p style={st.texto}>{texto}</p>
    </div>
  );
}

function MisionVisionPage() {
  const [mision, setMision] = useState(null);
  const [vision, setVision] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([fetchContenido('mision'), fetchContenido('vision')])
      .then(([m, v]) => { setMision(m.data); setVision(v.data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={st.cargando}>Cargando...</p>;

  return (
    <div style={st.pagina}>
      <h1 style={st.tituloPrincipal}>Misión &amp; Visión</h1>
      <div style={st.separador} />
      <div className="mv-grid">
        {mision && (
          <Seccion
            icono="🎯"
            titulo={mision.titulo}
            texto={mision.contenido}
            color="#1a1a2e"
          />
        )}
        {vision && (
          <Seccion
            icono="🔭"
            titulo={vision.titulo}
            texto={vision.contenido}
            color="#0f766e"
          />
        )}
      </div>
    </div>
  );
}

const st = {
  pagina:         { maxWidth: 1000, margin: '40px auto', padding: '0 20px' },
  tituloPrincipal:{ fontSize: 30, fontWeight: 700, color: '#1a1a2e', margin: '0 0 10px' },
  separador:      { width: 60, height: 4, backgroundColor: '#1a1a2e', borderRadius: 2, marginBottom: 32 },
  grid:           {},
  seccion:        {
    backgroundColor: '#fff', borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)', padding: '32px 36px',
  },
  seccionHeader:  { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 },
  seccionTitulo:  { fontSize: 22, fontWeight: 700, margin: 0 },
  texto:          { fontSize: 15, lineHeight: 1.8, color: '#374151', whiteSpace: 'pre-line', margin: 0 },
  cargando:       { textAlign: 'center', marginTop: 60, color: '#888' },
};

export default MisionVisionPage;
